class TrackElement {
  /**
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.element = element;
    this.gap = parseInt(window.getComputedStyle(element).gap) || 0;
  }

  get isTurboFrame() {
    return this.element.tagName === 'TURBO-FRAME';
  }

  get style() {
    return this.element.style;
  }

  indexOf(slideElement) {
    return Array.from(this.element.children).indexOf(slideElement);
  }

  move(value, transition = false) {
    const transform = `translateX(${-value}px)`;

    if (!transition) {
      return this.#transform('none', transform);
    }

    this.#afterNextFrame(() => this.#transform('all 200ms ease-out', transform));
  }

  #transform(transition, transform) {
    this.style.transition = transition;
    this.style.transform = transform;
  }

  #afterNextFrame(callback) {
    requestAnimationFrame(() => requestAnimationFrame(callback));
  }
}

export default TrackElement;
